import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { isoOf, flagOf } from "../lib/flags";
// FlagCDN provides PNGs at fixed widths (w20, w40, w80, w160, …). We pick the
// next-larger preset and let the browser scale down — keeps every flag crisp
// on hi-DPI screens. Falls back to the emoji on load error (no network, blocked
// CDN, unknown team).
function preset(size) {
    if (size <= 20)
        return 40;
    if (size <= 40)
        return 80;
    if (size <= 80)
        return 160;
    if (size <= 160)
        return 320;
    return 640;
}
export function Flag({ team, size = 28, className = "" }) {
    const iso = isoOf(team);
    const [failed, setFailed] = useState(false);
    if (!iso || failed) {
        return _jsx("span", { className: className, style: { fontSize: size }, children: flagOf(team) });
    }
    const w = preset(size);
    const w2 = preset(size * 2);
    return (_jsx("img", { src: `https://flagcdn.com/w${w}/${iso}.png`, srcSet: `https://flagcdn.com/w${w}/${iso}.png 1x, https://flagcdn.com/w${w2}/${iso}.png 2x`, alt: team ?? "", onError: () => setFailed(true), className: `inline-block rounded shadow-sm object-cover ${className}`, style: { width: size, height: Math.round(size * 0.75) } }));
}
